import React from "react";
import { useSite } from "@/context/SiteContext";

export default function WhatsAppButton() {
  const { settings } = useSite();
  const number = (settings.whatsapp || "").replace(/\D/g, "");
  if (!number) return null;
  const msg = encodeURIComponent(`Hi ${settings.company_name || "Aimway"}, I'd like to know more about your helmet sanitization machine.`);
  return (
    <a
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] shadow-soft transition-transform duration-200 hover:scale-110"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-button"
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white">
        <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.36.69 4.56 1.877 6.41L4 29l7.79-1.84A11.94 11.94 0 0 0 16 27c6.627 0 12-5.373 12-12S22.628 3 16.001 3zm0 21.8c-1.94 0-3.75-.57-5.27-1.55l-.38-.24-4.62 1.09 1.1-4.5-.25-.39A9.77 9.77 0 0 1 6.2 15c0-5.4 4.4-9.8 9.8-9.8s9.8 4.4 9.8 9.8-4.4 9.8-9.8 9.8zm5.62-7.34c-.31-.16-1.83-.9-2.11-1-.28-.1-.49-.16-.7.16-.2.31-.8 1-.98 1.2-.18.2-.36.23-.67.08-.31-.16-1.31-.48-2.5-1.54-.92-.82-1.54-1.84-1.72-2.15-.18-.31-.02-.48.14-.63.14-.14.31-.36.47-.55.16-.18.2-.31.31-.52.1-.2.05-.39-.03-.55-.08-.16-.7-1.69-.96-2.31-.25-.6-.51-.52-.7-.53l-.6-.01c-.2 0-.55.08-.83.39-.28.31-1.09 1.07-1.09 2.6s1.12 3.02 1.28 3.23c.16.2 2.2 3.36 5.33 4.71.74.32 1.32.51 1.77.65.74.24 1.42.2 1.95.12.6-.09 1.83-.75 2.09-1.47.26-.72.26-1.34.18-1.47-.08-.13-.28-.2-.59-.36z" />
      </svg>
    </a>
  );
}
